module.exports = {
    // ORANGE
    lightOrange: {
        'base-color': '#ff3d00'
    },
    darkOrange: {
        'base-color': '#ff3d00'
    },
    // BLUE
    lightBlue: {
        'base-color': '#3498ff'
    },
    darkBlue: {
        'base-color': '#3498ff'
    },
    // GREEN
    lightGreen: {
        'base-color': '#429321'
    },
    darkGreen: {
        'base-color': '#429321'
    },
    // GREY
    lightGrey: {
        'base-color': '#607d8b'
    },
    darkGrey: {
        'base-color': '#607d8b'
    },
};
